import { useCallback, useEffect, useState } from "react";
import { platform } from "@/platform";
import { t } from "@/i18n/ko";
import { usePushStore } from "@/stores/pushStore";
import { useUiStore } from "@/stores/uiStore";
import { disablePush, enablePush } from "./push";

/**
 * 설정 "푸시 알림" 스위치(AC0-260, 앱 전용). 켜짐 = OS 권한 허용 && 설정에서 끄지 않음.
 * 켜기: OS 권한을 아직 묻지 않았으면 시스템 창, 이미 거부(다시 못 물음)면 기기 설정 안내 스낵바. 끄기: 이 기기 토큰을 서버에서 지운다.
 * 포그라운드 복귀 때 다시 읽는다(기기 설정에서 바꾸고 돌아온 경우).
 */
export function usePushSetting(): { visible: boolean; on: boolean; toggle: (next: boolean) => void } {
  const visible = platform.clientKind !== "web";
  const off = usePushStore((s) => s.off);
  const [granted, setGranted] = useState(false);

  const refresh = useCallback(() => {
    void platform.push.permission().then((p) => setGranted(p === "granted"));
  }, []);

  useEffect(() => {
    if (!visible) return;
    refresh();
    return platform.app.onForeground(refresh);
  }, [visible, refresh]);

  const toggle = (next: boolean) => {
    if (!next) {
      void disablePush();
      return;
    }
    void enablePush().then((p) => {
      setGranted(p === "granted");
      if (p === "denied") useUiStore.getState().showSnackbar(t("settings.push.osDenied"));
    });
  };

  return { visible, on: granted && !off, toggle };
}
